import { Button, Form, FormInstance, Select } from 'antd';
import ChevronDownIcon from 'assets/icons/chevron-down.svg';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { commonHelpers } from 'utilities/helpers';

export const DesiredSellingPrice = (props: {
    isDisabled: boolean;
    defaultValue?: number;
    form: FormInstance<any>;
}) => {
    const { propertyId, registeredId } = useParams();
    const navigate = useNavigate();
    const [priceOptions, setPriceOptions] = useState<{ value?: number; name?: number }[]>([]);

    useEffect(() => {
        generateLoanOption(props.defaultValue);
        props.form.setFieldValue('price', props.defaultValue);
    }, [props.defaultValue]);

    const generateLoanOption = (defaultValue?: number) => {
        const options: { value?: number; name?: number }[] = [];
        if (defaultValue && defaultValue < 0) {
            options.push({
                value: props.defaultValue,
                name: props.defaultValue,
            });
        }

        for (let i = 0; i <= 9990; i += 10) {
            if (props.defaultValue && props.defaultValue < i && props.defaultValue > i - 10) {
                options.push({
                    value: props.defaultValue,
                    name: props.defaultValue,
                });
            }
            options.push({
                value: i,
                name: i,
            });
        }
        setPriceOptions(options);
    };

    return (
        <>
            <section style={{ width: '100%', marginBottom: 16 }} className="input-number-custom">
                <div style={{ marginBottom: 12 }} className="label-form">
                    売却希望価格<span style={{ color: '#EB5757' }}>*</span>
                </div>
                <Form.Item
                    style={{ margin: 0, padding: 0 }}
                    required={false}
                    className="input-font-style label-form-style  "
                    name="price"
                    label={false}
                    rules={[
                        {
                            required: true,
                            message: 'required message',
                        },
                    ]}
                >
                    <Select
                        className="select-custom"
                        size="large"
                        suffixIcon={
                            <div className="center-inside">
                                <div style={{ marginRight: 14 }} className="suffix-select-font">
                                    万円
                                </div>
                                <img alt="" src={ChevronDownIcon} />
                            </div>
                        }
                        placeholder={PLACEHOLDER.DESIRED_SALE_PRICE}
                    >
                        {priceOptions.map((element) => (
                            <Select.Option
                                className="option-style"
                                key={element.value}
                                value={element.value}
                            >
                                {commonHelpers.formatNumberMoney(element.name)}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </section>
            <section
                style={{
                    width: '100%',
                    justifyContent: 'space-between',
                    display: 'flex',
                }}
            >
                <Button
                    className="button-login-text"
                    style={{
                        width: 165.5,
                        height: 56,
                        color: '#28323C',
                    }}
                    onClick={() =>
                        navigate(
                            `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_031_01}/${propertyId}/${registeredId}/${5}/${'loanBalance'}`,
                        )
                    }
                >
                    戻る
                </Button>
                <Button
                    type="primary"
                    className="button-login-text"
                    style={{ width: 165.5, height: 56 }}
                    disabled={props.isDisabled}
                    htmlType="submit"
                >
                    本査定へ進む
                </Button>
            </section>
        </>
    );
};
